function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVhazzatOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g862",
    transform: "matrix(0.99964688,0,0,1.0003434,5.2291813e-5,-3.9184107e-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path21392",
    style: {
      fill: "#c2e7eb",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313113px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 4.0787977,0.11238752 5.1829272,1.038971 M 0.15026792,0.14900469 H 4.0265153 V 1.0756001 H 5.1306449 V 6.448301 H 0.15026792 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g856"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: "0.313113px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 0.85462093,5.5254554 1.6223151,4.1800244",
    id: "path21647"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.313607,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 2.227174,5.4509949 3.7207624,2.8333672",
    id: "path21649"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVhazzatOn);
export default __webpack_public_path__ + "static/media/vhazzat_on.eea9ca5d60c625ab86c65ba1c4a418ec.svg";
export { ForwardRef as ReactComponent };